import { render } from "./VaultsFilterWithSearch.vue?vue&type=template&id=79f365d3&scoped=true&ts=true"
import script from "./VaultsFilterWithSearch.vue?vue&type=script&lang=ts"
export * from "./VaultsFilterWithSearch.vue?vue&type=script&lang=ts"

import "./VaultsFilterWithSearch.vue?vue&type=style&index=0&id=79f365d3&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f365d3"]])

export default __exports__